<template>
  <span>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >
          <v-icon color="teal darken-1" v-if="status === $constants.AMB_POI_STATUSES.DONE">
            mdi-check-circle
          </v-icon>
          <v-icon color="indigo darken-3" v-if="status === $constants.AMB_POI_STATUSES.UPLOADED">
            mdi-cloud-upload
          </v-icon>
          <v-icon color="indigo darken-3" v-if="status === $constants.AMB_POI_STATUSES.DOWNLOADED">
            mdi-monitor-arrow-down
          </v-icon>
          <v-icon color="indigo darken-3" v-if="status === $constants.AMB_POI_STATUSES.FOR_EDITOR">
            mdi-movie-edit
          </v-icon>
          <v-icon color="orange darken-3" v-if="status === $constants.AMB_POI_STATUSES.IN_REVIEW">
            mdi-timer-sand
          </v-icon>
          <v-icon v-if="status === $constants.AMB_POI_STATUSES.NEW">
            mdi-clock-outline
          </v-icon>
        </span>
      </template>
      <span>{{ statusName() }}</span>
    </v-tooltip>
  </span>
</template>

<script>
export default {
  name: 'AmbStatusIcon',
  props: {
    status: {
      type: Number,
      default: -1,
    },
    statuses: {
      type: Array,
      default() {
        return [];
      },
    },
    uploadUser: {
      type: String,
      default: '',
    },
    uploadUserDate: {
      type: String,
      default: '',
    },
  },
  methods: {
    statusName() {
      let status = this.statuses.find((item) => item.id === this.status);
      status = status ? status.name : '';

      if (this.uploadUser) {
        status = `${status} by ${this.uploadUser}`;
      }

      if (this.uploadUserDate) {
        const d = new Date(this.uploadUserDate);
        status = `${status} ${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
      }

      return status;
    },
  },
};
</script>
